export default __webpack_public_path__ + "static/media/github-logo2.364015ca.png";